import { Glyph } from "./Glyph";
import type { InputHTMLAttributes, Ref, SelectHTMLAttributes, TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
const FIELD_CLASS = "rounded-field bg-surface text-body text-ink shadow-hairline placeholder:text-ink-3 touch:text-field " + "aria-[invalid=true]:shadow-hairline-danger focus:outline-none focus:shadow-focus-field " + "disabled:cursor-not-allowed disabled:bg-offwhite disabled:text-ink-3";
const TEXT_INPUT_SIZE = {
  md: "h-10 px-3.5",
  sm: "h-8 px-2.5 text-callout"
} as const;
export function TextInput({
  className,
  size = "md",
  ref,
  ...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, "size"> & {
  size?: keyof typeof TEXT_INPUT_SIZE;
  ref?: Ref<HTMLInputElement>;
}) {
  return <input ref={ref} className={cn("w-full", FIELD_CLASS, TEXT_INPUT_SIZE[size], className)} {...props} data-sentry-component="TextInput" data-sentry-source-file="inputs.tsx" />;
}
export function TextArea({
  className,
  ref,
  ...props
}: TextareaHTMLAttributes<HTMLTextAreaElement> & {
  ref?: Ref<HTMLTextAreaElement>;
}) {
  return <textarea ref={ref} className={cn("min-h-[80px] w-full px-3.5 py-2.5 leading-relaxed", FIELD_CLASS, className)} {...props} data-sentry-component="TextArea" data-sentry-source-file="inputs.tsx" />;
}
export function SelectField({
  className,
  selectClassName,
  children,
  ref,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement> & {
  selectClassName?: string;
  ref?: Ref<HTMLSelectElement>;
}) {
  return <span className={cn("relative inline-flex", className)} data-sentry-component="SelectField" data-sentry-source-file="inputs.tsx">
            <select ref={ref} className={cn("h-10 w-full appearance-none pl-3.5 pr-8", FIELD_CLASS, selectClassName)} {...props}>
                {children}
            </select>
            <Glyph name="chevronDown" className="pointer-events-none absolute right-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-ink-3" aria-hidden="true" data-sentry-element="Glyph" data-sentry-source-file="inputs.tsx" />
        </span>;
}
export function UnitInput({
  className,
  unit,
  ref,
  ...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, "size"> & {
  unit: string;
  ref?: Ref<HTMLInputElement>;
}) {
  return <span className={cn("relative inline-flex w-20", className)} data-sentry-component="UnitInput" data-sentry-source-file="inputs.tsx">
            <input ref={ref} inputMode="decimal" className={cn("h-8 w-full pl-2.5 pr-7 text-right text-callout tabular-nums", FIELD_CLASS)} {...props} />
            <span className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-callout text-ink-3" aria-hidden="true">
                {unit}
            </span>
        </span>;
}